import "./style.scss";

import Logo from "assets/img/svg/navbar/logo";
import LoadingDots from "components/LoadingDots";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { authBexioCallback, authGoogleCallback, fetchIntegrations } from "store/integrationsStore";
import { useAppDispatch } from "store/store";

import type { TIntegrationName } from "../../components/IntegrationsSettings/types";
import type { TFetchStatus } from "../../store/types";
import FailedContent from "./FailedContent";
import SucceededContent from "./SucceededContent";

const OAuthCallbackComponent = () => {
    const [t] = useTranslation();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const redirectionPath = localStorage.getItem("oauthRedirectionPath");
    const [searchParams, _] = useSearchParams();

    const [authorization, setAuthorization] = useState<"succeeded" | "failed" | "idle">("idle");
    const [count, setCount] = useState(5);

    const [integration, setIntegration] = useState<TIntegrationName | undefined>(undefined);
    const [ingregrationStatus, setIntegrationStatus] = useState<TFetchStatus>("idle");

    const { type } = useParams();

    useEffect(() => {
        onAuthCallback();
    }, [dispatch, type]);

    const onAuthCallback = async () => {
        const code = searchParams.get("code")!;

        setIntegration(type as TIntegrationName | undefined);

        let response;
        switch (type) {
            case "bexio":
                response = await dispatch(authBexioCallback(code));
                break;
            case "google":
            default:
                response = await dispatch(authGoogleCallback(code));
                break;
        }

        if (response.meta.requestStatus === "fulfilled") {
            dispatch(fetchIntegrations());
            setAuthorization("succeeded");
        } else if (response.meta.requestStatus === "rejected") {
            setAuthorization("failed");
            setIntegrationStatus("failed");
        }
    };

    const redirect = () => {
        navigate(redirectionPath as string);
    };

    useEffect(() => {
        const interval = setInterval(() => {
            setCount((prevCount) => prevCount - 1);
        }, 1000);

        if ((authorization === "succeeded" || authorization === "failed") && count <= 0) {
            redirect();
        }

        return () => clearInterval(interval);
    }, [ingregrationStatus, count]);

    const connectPopup = {
        succeeded: <SucceededContent integration={integration} />,
        failed: <FailedContent onRedirect={() => redirect()} />,
        idle: <></>,
    };

    return (
        <div className="integration-connect">
            <div className="crealo-logo">
                <Logo />
            </div>
            {connectPopup[authorization]}
            {authorization !== "idle" && (
                <span className="redirect-in">
                    {`${t("IntegrationsSettings.RedirectIn")} ${count} ${t("IntegrationsSettings.Seconds")}`}
                    <LoadingDots />
                </span>
            )}
        </div>
    );
};

export default OAuthCallbackComponent;
